import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from "antd";
const ProjectDetailMultiproductModal = ({ isModalOpen, handleOk, handleCancel, modalContent, title }) => {
    const columns = [
        {
            title: 'S No.',
            dataIndex: 'serialNo',
            key: 'serialNo',
        },
        {
            title: 'Product Name',
            dataIndex: 'productName',
            key: 'productName',
        },
        {
            title: 'Product Model',
            dataIndex: 'productModel',
            key: 'productModel',
        },
        {
            title: 'Brand/OEM',
            dataIndex: 'brandName',
            key: 'brandName',
        },
    ];
    const dataSource = modalContent === null || modalContent === void 0 ? void 0 : modalContent.map((data, index) => {
        var _a;
        return {
            key: index,
            serialNo: index + 1,
            productName: data === null || data === void 0 ? void 0 : data.strProductNameEN,
            productModel: data === null || data === void 0 ? void 0 : data.strPrimaryModel,
            brandName: (_a = data === null || data === void 0 ? void 0 : data.objBrandName) === null || _a === void 0 ? void 0 : _a.strLongDesc,
        };
    });
    return (_jsx(Modal, { title: title, open: isModalOpen, onOk: handleOk, onCancel: handleCancel, children: _jsx(Table, { columns: columns, dataSource: dataSource }) }));
};
export default ProjectDetailMultiproductModal;
